// The home widgets' numerals (HOME_WIDGETS_SPEC.md §2 "Hero", DESIGN_SPEC L43):
// compact by contract, so a hero never needs an ellipsis.
//
//   homeCompactNumber(3420)          → '3,420'   (a count stays exact below 10K)
//   homeCompactNumber(48213)         → '48.2K'
//   homeCompactNumber(86_900_000)    → '86.9M'
//   homeMoney(1234.5, 'usd')         → 'USD 1.2K' (money compacts from 1K)
//   homeMoney(64638, 'GEL')          → 'GEL 64.6K'
//
// Grouping and the compact suffixes are en-US on purpose — the house money
// rule (the ISO code word + the number, never a symbol) and one notation on
// every board, whatever the session language. The code and the amount are
// joined by a no-break space, so the code never wraps away from its number.
export const homeCompactNumber = function homeCompactNumber(value, threshold) {
  if (value === null || value === undefined || value === '') return ''
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  const from = Number(threshold) > 0 ? Number(threshold) : 10000
  const opts =
    Math.abs(n) >= from
      ? { notation: 'compact', maximumFractionDigits: 1 }
      : { maximumFractionDigits: Math.abs(n) < 10 && n % 1 ? 1 : 0 }
  try {
    return new Intl.NumberFormat('en-US', opts).format(n)
  } catch (_) {
    return String(Math.round(n))
  }
}

export const homeMoney = function homeMoney(value, currency) {
  const s = String(currency == null ? '' : currency).trim()
  const code = /^[a-z]{3}$/i.test(s) ? s.toUpperCase() : s
  const amount = homeCompactNumber(value, 1000)
  if (!amount) return ''
  return code ? code + ' ' + amount : amount
}
